/**
 * Shared overlay configuration and utilities
 */

/**
 * Default configurations for different types of overlays
 */
export const overlayDefaults = {
  sidebar: {
    type: 'sidebar',
    position: 'right',
    size: 'lg',
    backdrop: true,
    closeOnBackdrop: false, // We handle this manually for confirmation
    closeOnEscape: false,   // We handle this manually for confirmation
  },
  modal: {
    type: 'modal',
    position: 'center',
    size: 'md',
    backdrop: true,
    closeOnBackdrop: true,
    closeOnEscape: true,
  },
  confirmModal: {
    type: 'modal',
    position: 'center',
    size: 'sm',
    backdrop: true,
    closeOnBackdrop: false,
    closeOnEscape: true,
  }
};

/**
 * Creates a sidebar configuration with confirmation support
 * @param {Object} config - Custom configuration
 * @returns {Object} Complete sidebar configuration
 */
export function createSidebarConfig(config = {}) {
  return {
    ...overlayDefaults.sidebar,
    ...config
  };
}

/**
 * Creates a modal configuration
 * @param {Object} config - Custom configuration
 * @returns {Object} Complete modal configuration
 */
export function createModalConfig(config = {}) {
  return {
    ...overlayDefaults.modal,
    ...config
  };
}

/**
 * Creates a confirmation modal configuration
 * @param {Object} config - Custom configuration
 * @returns {Object} Complete confirmation modal configuration
 */
export function createConfirmModalConfig(config = {}) {
  return {
    ...overlayDefaults.confirmModal,
    ...config
  };
}

